export const GET_SKINCONCERNS_STATED = "GET_SKINCONCERNS_STATED";
export const GET_SKINCONCERNS = "GET_SKINCONCERNS";
export const GET_SKINCONCERNS_ENDED = "GET_SKINCONCERNS_ENDED";
export const ADD_SKINCONCERN_STATED = "ADD_SKINCONCERN_STARTED";
export const ADD_SKINCONCERN = "ADD_SKINCONCERN";
export const ADD_SKINCONCERN_ENDED = "ADD_SKINCONCERN_ENDED";
export const EDIT_SKINCONCERN_STATED = "EDIT_SKINCONCERN_STATED";
export const EDIT_SKINCONCERN = "EDIT_SKINCONCERN";
export const EDIT_SKINCONCERN_ENDED = "EDIT_SKINCONCERN_ENDED";
export const GET_SKINCONCERN = "GET_SKINCONCERN";
export const GET_SKINCONCERN_STATED = "GET_SKINCONCERN_STATED";
export const GET_SKINCONCERN_ENDED = "GET_SKINCONCERN_ENDED";
export const RESET_SKINCONCERN = "RESET_SKINCONCERN";
export const ERROR_SKINCONCERN = "ERROR_SKINCONCERN";
export const GET_ALL_SKINCONCERNS_STATED = "GET_ALL_SKINCONCERNS_STATED";
export const GET_ALL_SKINCONCERNS = "GET_ALL_SKINCONCERNS";
export const GET_ALL_SKINCONCERNS_ENDED = "GET_ALL_SKINCONCERNS_ENDED";
